import supabase, { getSupabase } from "./client";

export default supabase;
export { supabase, getSupabase };

export const getSupabaseClient = getSupabase;
export const hasAuthAPI = () => !!supabase?.auth;
